import React from 'react';
import { css } from '@emotion/react';
import { i18n_connect_and_grow_with_top_instructors } from '@yi/i18n/phrases/i18n_connect_and_grow_with_top_instructors';
import { i18n_our_world_class_teachers_come_from_multitude_of_educational_backgrounds_and_experiences_and_to } from '@yi/i18n/phrases/i18n_our_world_class_teachers_come_from_multitude_of_educational_backgrounds_and_experiences_and_to';

import { useLocale } from '~/src/components/LocaleProvider';
import { breakpoints, paddingVariables, typography } from '~/src/styles';

import { TeachersCarousel } from './TeachersCarousel';
import { commonStyles } from '../common-styles';

const styles = {
  heading: css(commonStyles.contentPadding, typography.heading1, {
    gridArea: 'heading',
    color: 'var(--Dark-Text, #27292D)',
  }),
  details: css(commonStyles.contentPadding, typography.bodyText, {
    color: 'var(--Grey-Text, #585858)',
    gridArea: 'details',
    margin: 0,
    [breakpoints.minTablet]: [
      typography.subHeading1,
      {
        color: 'var(--Grey-Text, #585858)',
      },
    ],
  }),
  carousel: css(commonStyles.contentPadding, commonStyles.carouselContainerStyles, {
    gridArea: 'carousel',
  }),
  container: css({
    display: 'grid',
    overflowX: 'hidden',
    gridTemplateAreas: `
        '.'
        'heading'
        '.'
        'details'
        '.'
        'carousel'
        '.'
    `,
    // NOTE: Teacher carousel has strangle layout. To keep backward compatibility it stay untouched. That's why the last padding is custom
    gridTemplateRows: `${paddingVariables.p56} auto ${paddingVariables.p16} auto ${paddingVariables.p56} auto 4px`,
    [breakpoints.minTablet]: {
      gridTemplateRows: `${paddingVariables.p80} auto ${paddingVariables.p24} auto ${paddingVariables.p56} auto ${paddingVariables.p56}`,
    },
    [breakpoints.minDesktop]: {
      gridTemplateAreas: `
        '. . .'
        '. heading .'
        '. . .'
        '. details .'
        '. . .'
        '. carousel .'
        '. . .'
    `,
      gridTemplateColumns: `1fr var(--Max-Desktop-Width) 1fr`,
      gridTemplateRows: `${paddingVariables.p120} auto ${paddingVariables.p32} auto ${paddingVariables.p120} auto ${paddingVariables.p120}`,
    },
  }),
};

export const ConnectAndGrowWithTopInstructors: React.FC = () => {
  const { locale } = useLocale();

  return (
    <section css={styles.container}>
      <h1 css={styles.heading}>{i18n_connect_and_grow_with_top_instructors(locale)}</h1>
      <h2 css={styles.details}>
        {i18n_our_world_class_teachers_come_from_multitude_of_educational_backgrounds_and_experiences_and_to(
          locale,
        )}
      </h2>
      <TeachersCarousel css={styles.carousel} />
    </section>
  );
};
